import React, { Component, useState, useEffect} from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import {
//     List, Edit, Create, Datagrid, Show, DateField, ReferenceManyField,
//     ReferenceField, TextField, ArrayField, ShowButton, SingleFieldList,
//     DisabledInput, ReferenceInput, AutocompleteInput,
//     SelectInput, SimpleForm, DeleteButton, NumberInput, DateInput, Filter, SimpleShowLayout, ImageInput, ImageField, EditButton, TopToolbar, required, SimpleFormIterator, ArrayInput, TextInput, 
// } from 'react-admin';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from './common/common';
import { useLocation } from "react-router-dom";

const SapProducts = (props) => {
    const [loadingShow, setLoadingShow] = useState(false);
    const [sap_products, setSap_products] = useState('');

    const location = useLocation();
    const pathSplit = location.pathname.split("/");
    const urlId = pathSplit[2];
  
    useEffect(() => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        setLoadingShow(true);
        fetch(`${apiUrl}/sap_contract_products/${props?.id || urlId}`, options)
        .then(res => {
            return res.json();
        }).then(jsonD => {
            let obj = {};
            obj.sap_products = jsonD.data;
            obj.loadingShow = false;
            setLoadingShow(false);
            setSap_products(jsonD.data)
            // this.setState({...obj});
        });
    },[])

        // const { props, state } = this;
        // console.log('state====>', state);
        return (
            <div>
            {
                !loadingShow &&
                <Scrollbars class="scroll-container">
                    <div {...props} title="Order Materials">
                        <div>
                            {   sap_products.length > 0 &&
                                <div className="data-box">
                                    <h2 className="data-heading">Contract Products for Contract No. : {props.id}</h2>
                                    <table className="data-table">
                                        <thead>
                                            <tr>
                                                <th> </th>
                                                <th>Material No.</th>
                                                <th>Material Desc.</th>
                                                <th>Position</th>
                                                <th>Plant Code</th>
                                                <th>Shipping Point</th>
                                                <th>Net Price</th>
                                                <th>Vat (%)</th>
                                                <th>Price after tax</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                sap_products.map(items => {
                                                    
                                                    return (
                                                        <tr key={items.id}>
                                                            <td></td>
                                                            <td>{items.material_number}</td>
                                                            <td>{items.material_description}</td>
                                                            <td>{items.position}</td>
                                                            <td>{items.plant_code}</td>
                                                            <td>{items.shipping_point}</td>
                                                            <td>{items.net_price}</td>
                                                            <td>{items.vat}</td>
                                                            <td>{items.price_after_tax}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            }
                        </div>
                    </div>
                </Scrollbars>
            }
            </div>
        );
}
export default SapProducts;
